import * as React from 'react';
import { SVGProps } from 'react';
import styled from 'styled-components';

const SVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m6.163 7.833 1.015-1.55a1.273 1.273 0 0 0 .105-1.199L5.97 2.024v-.001a1.27 1.27 0 0 0-1.322-.764h-.005A3.886 3.886 0 0 0 1.25 5.116a9.635 9.635 0 0 0 9.635 9.635 3.886 3.886 0 0 0 3.855-3.394v-.005a1.271 1.271 0 0 0-.763-1.322h-.001l-3.058-1.31a1.273 1.273 0 0 0-1.207.11L8.185 9.847a4.76 4.76 0 0 1-2.022-2.014Z"
      fill="currentColor"
    />
  </svg>
);

const StyledSvgPhone1 = styled(SVG)`
  font-size: ${props => (props.fontSize ? props.fontSize : '1.6rem')};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutralColors.charcoal};
  vertical-align: middle;
  shape-rendering: inherit;
  transform: translate3d(0, 0, 0);
`;
export default StyledSvgPhone1;
